import { LoadingButton } from '@mui/lab';
import { DialogActions, Box } from '@mui/material';
import { Modal } from '@scorenco/components';
import { useTranslation, AddChallengePhase } from '@scorenco/core';

import { T_KEYS } from '@/translations';

type AddRulesModalProps = {
  challengeId: number;
  newRank: number;
  closeModal: () => void;
};

export const AddRulesModal = ({
  challengeId,
  newRank,
  closeModal,
}: AddRulesModalProps) => {
  const insertPhaseMutation = AddChallengePhase();
  const { t } = useTranslation();

  return (
    <Modal
      title={t(T_KEYS.TOURNAMENTS_CHALLENGE_ADD_PHASE)}
      closeModal={closeModal}
    >
      <Box
        component="form"
        name="editnews"
        onSubmit={async (e) => {
          e.preventDefault();
          await insertPhaseMutation.execute({
            challengeId,
            phaseRank: newRank,
          });
          closeModal();
        }}
      >
        <DialogActions sx={{ m: 0, p: 1, justifyContent: 'center' }}>
          <LoadingButton
            type="submit"
            variant="contained"
            color="secondary"
            loading={insertPhaseMutation.status.loading}
          >
            {t(T_KEYS.ADD)}
          </LoadingButton>
        </DialogActions>
      </Box>
    </Modal>
  );
};
